const isCheckoutPage = $("#footercontent").hasClass("footer-checkout");

module.exports = {
    toSetTargetAttr: function () {
        if (isCheckoutPage) {
            $(".footer-checkout").find("a").attr("target", "_blank");
        }
    }
};
